<input class="form-check-input" id="three-state-checkbox{{idAndName}}" name="three-state-checkbox{{idAndName}}"
    type="checkbox" [indeterminate]="status == null" [ngModel]="status == true" (ngModelChange)="changeStatus()">
<label class="form-check-label" for="three-state-checkbox{{idAndName}}">{{label}}</label>